import * as React from "react"

function StoreTab({width =20,height=20. , fillColor="#FA5743", props}) {
  return (
      <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 5.317v1.519a3.798 3.798 0 006.836 2.278 3.792 3.792 0 003.038 1.52 3.792 3.792 0 003.038-1.52 3.798 3.798 0 006.835-2.278v-1.52a.759.759 0 00-.07-.318l-1.696-3.675A2.278 2.278 0 0015.913 0H3.834a2.279 2.279 0 00-2.067 1.323L.07 5a.76.76 0 00-.07.318zm1.519 6.645a.95.95 0 01.95.95v5.126h4.367v-2.041a3.038 3.038 0 116.076 0v2.041h4.367v-5.126a.95.95 0 011.899 0v5.316a1.709 1.709 0 01-1.71 1.71H2.279a1.709 1.709 0 01-1.708-1.71v-5.316a.95.95 0 01.949-.95z"
        fill={fillColor}
      />
    </svg>
  )
}

export default StoreTab
